import script from "./SidebarTrigger.vue?vue&type=script&lang=js"
export * from "./SidebarTrigger.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__